import React from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import OfferTime from "../common/event-offer-groups/components/OfferTime";
import EventName from "../common/event-offer-groups/components/EventName";
import BettingType from "../common/event-offer-groups/components/BettingType";

export default observer(function SharedBetSlipOfferItem(props: {
	offer: BetOffer;
	groupHasTitle: boolean;
	offersHaveColor: boolean;
	isSystem: boolean;
}) {
	const colorClass = props.offersHaveColor
		? `u-color--offer--${props.offer.formattedBettingOfferStatus}`
		: "";

	return (
		<>
			<OfferTime
				offer={props.offer}
				groupHasTitle={props.groupHasTitle}
			/>
			<div className="bet__pick">
				{props.isSystem && (
					<div className="bet__combi">
						{props.offer.systemIdentifier}
					</div>
				)}

				<div className={"bet__pick__inner"}>
					<div className="bet__pick__row">
						<div
							className={`bet__status ${props.offer.formattedBettingOfferStatus}`}
						>
							<div
								className={`bet__status__indicator ${props.offer.formattedBettingOfferStatus}`}
							></div>
						</div>
						{props.offer.isBank === true && (
							<div className="bet__bank tag tag--tny tag--success">
								B
							</div>
						)}
						<div className="bet__type">
							{!props.groupHasTitle && (
								<EventName offer={props.offer} />
							)}{" "}
							<BettingType
								offer={props.offer}
								colorClass={colorClass}
							/>
						</div>
						<div className={"bet__quote " + colorClass}>
							{props.offer.value.toFixed(2)}
						</div>
					</div>
				</div>
				{/* 			<div className="bet__quote__wrapper">
					<div className={"bet__quote " + colorClass}>
						{props.offer.value.toFixed(2)}
					</div>
				</div> */}
			</div>
		</>
	);
});
